import { connect } from "react-redux";

import { hideModal, showModal } from "../../../../actions/modals";
import { showToast } from "../../../../actions/toasts";
import { putNormalizedEntities } from "../../../../helpers";
import modalTypes from "../../../../constants/modalTypes";
import {
    getCeremonyBlockWithAssetsById,
    getWalkInBlockId,
    getWalkOutBlockId,
} from "../../../../selectors/blocks";

import BlockPhotoProcessingFailureModalContainer from "./BlockPhotoProcessingFailureModalContainer";

const mapStateToProps = (state, props) => {
    const ceremonyId = parseInt(props.ceremonyId);
    const blockId = parseInt(props.blockId);
    const block = getCeremonyBlockWithAssetsById(state, { ceremonyId, blockId });

    return {
        block,
        blockId,
        ceremonyId,
        isVisible: true,
        isWalkInBlock: blockId === getWalkInBlockId(state, ceremonyId),
        isWalkOutBlock: blockId === getWalkOutBlockId(state, ceremonyId),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const ceremonyId = parseInt(props.ceremonyId);
    const blockId = parseInt(props.blockId);

    return {
        hideModal: () => dispatch(hideModal()),
        showToast: (options) => dispatch(showToast(options)),
        updateStoreEntities: (entities) => putNormalizedEntities(dispatch, entities),
        showBlockEditModal: ({ isWalkInBlock, isWalkOutBlock }) => {
            dispatch(hideModal());
            dispatch(
                showModal({
                    type: modalTypes.BLOCK_EDIT,
                    props: {
                        ceremonyId,
                        blockId,
                        isWalkInBlock,
                        isWalkOutBlock,
                    },
                })
            );
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BlockPhotoProcessingFailureModalContainer);
